<template>
  <div v-if="Student != null" class="container">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-auto pr-0">
            <span class="material-icons pointer" v-on:click="editStudent">
              edit
            </span>
          </div>
          <div class="col text-left">
            <h4 class="mb-0">{{ Student.Name }}</h4>
          </div>
          <div class="col-auto">
            <button
              v-if="page == 1"
              class="btn btn-link text-danger"
              v-on:click="showArchivedData"
            >
              Archived Data
            </button>
            <button
              v-if="page == 2"
              class="btn btn-link"
              v-on:click="showCurrentData"
            >
              Current Data
            </button>
          </div>
        </div>
      </div>
      <div
        class="card-body"
        v-bind:class="{ 'archive-background border border-danger': page == 2 }"
      >
        <div v-if="page == 1">
          <!-- Student Groups -->
          <div class="row">
            <div class="col-auto pr-0">
              <button class="btn btn-sm btn-primary" v-on:click="manageStudent">
                Manage
              </button>
            </div>
            <div class="col-auto">
              <p class="mb-0 pt-1"><b>Groups:</b></p>
            </div>
            <div
              class="col-auto"
              v-for="organization in Student.Organizations"
              :key="organization.Organization_Id"
            >
              <p class="mb-0 pt-1">{{ organization.Name }}</p>
            </div>
            <div class="col" />
          </div>
          <!-- Student Subjects -->
          <div
            class="row ml-2 mt-2"
            v-for="subject in Student.Subjects.slice().sort($orderByTitle)"
            :key="subject.Subject_Id"
          >
            <div class="col-auto">
              <p class="my-0">
                <strong>{{ subject.Title }}</strong>
              </p>
            </div>
            <div
              class="col-auto"
              v-for="StudentUnit in Student.Student_Units.filter(
                u => u.Unit.Subject_Id == subject.Subject_Id
              )
                .slice()
                .sort($orderByUnitTitle)"
              :key="StudentUnit.Unit_Id"
            >
              <p
                class="pointer btn-link mb-0"
                v-on:click="selectUnitScores(StudentUnit)"
              >
                {{ StudentUnit.Unit.Title }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p v-if="Student.Subjects.length == 0" class="mb-0">
                This Student is not assigned to any subjects.
              </p>
            </div>
          </div>
          <!-- Student Behavior Trackers -->
          <div class="row mt-4">
            <div
              v-if="
                $canManageStudent(
                  this.$store.getters.user.Permissions,
                  Student.Student_Id
                )
              "
              class="col-auto pr-0"
            >
              <button class="btn btn-sm btn-primary" v-on:click="addBehavior">
                Add Tracker
              </button>
            </div>
            <div class="col text-left">
              <p class="mb-0 pt-1"><b>Behavior:</b></p>
            </div>
          </div>
          <div class="row ml-2 mt-2">
            <div
              class="col-auto"
              v-for="tracker in BehaviorTrackers.filter(
                t =>
                  t.Is_Archived == false &&
                  t.Student.Student_Id == Student.Student_Id
              )"
              :key="tracker.Behavior_Tracker_Id + 'tracker'"
            >
              <button
                class="btn btn-link"
                v-on:click="selectBehaviorScores(tracker)"
              >
                {{ tracker.Title }}
              </button>
            </div>
          </div>
          <!-- Student Managers -->
          <div class="row mt-4">
            <div
              v-if="
                $canManageStudent(
                  this.$store.getters.user.Permissions,
                  Student.Student_Id
                )
              "
              class="col-auto pr-0"
            >
              <button
                class="btn btn-sm btn-primary"
                v-on:click="manageStudentManagers"
              >
                Manage
              </button>
            </div>
            <div class="col-auto text-left">
              <p class="mb-0 pt-1"><b>Student Managers:</b></p>
            </div>
          </div>
          <div class="row ml-2 mt-2">
            <div
              class="col-auto"
              v-for="user in Users.filter(u =>
                u.Permissions.some(p => p.Student_Id == Student.Student_Id)
              )
                .slice()
                .sort($orderByLastName)"
              :key="user.User_Id + 'user'"
            >
              <p class="pt-1">{{ user.First_Name }} {{ user.Last_Name }}</p>
            </div>
          </div>
        </div>

        <!-- Archived Data -->
        <div v-if="page == 2">
          <div class="row">
            <div class="col text-left">
              <p class="mb-0 pt-1"><b>Archived Subjects and Units:</b></p>
            </div>
          </div>
          <div
            class="row ml-2 mt-2"
            v-for="subject in allSubjects.slice().sort($orderByTitle)"
            :key="subject.Subject_Id"
          >
            <div class="col-auto">
              <p class="my-0">
                <strong>{{ subject.Title }}</strong>
              </p>
            </div>
            <div
              class="col-auto"
              v-for="StudentUnit in archivedStudentUnits
                .filter(u => u.Unit.Subject_Id == subject.Subject_Id)
                .slice()
                .sort($orderByUnitTitle)"
              :key="StudentUnit.Unit_Id"
            >
              <p
                class="pointer btn-link mb-0"
                v-on:click="selectUnitScores(StudentUnit)"
              >
                {{ StudentUnit.Unit.Title }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p v-if="allSubjects.length == 0" class="mb-0">
                This Student is not assigned to any subjects.
              </p>
            </div>
          </div>
          <!-- Student Behavior Trackers -->
          <div class="row mt-4">
            <div class="col text-left">
              <p class="mb-0 pt-1"><b>Archived Behavior:</b></p>
            </div>
          </div>
          <div class="row ml-2 mt-2">
            <div
              class="col-auto"
              v-for="tracker in BehaviorTrackers.filter(
                t =>
                  t.Is_Archived == true &&
                  t.Student.Student_Id == Student.Student_Id
              )"
              :key="tracker.Behavior_Tracker_Id + 'tracker'"
            >
              <button
                class="btn btn-link"
                v-on:click="selectBehaviorScores(tracker)"
              >
                {{ tracker.Title }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <StudentUnitScores
      v-if="scoreTemplate != null"
      v-bind:Student="Student"
      v-bind:ScoreTemplate="scoreTemplate"
      v-bind:Scores="unitScores"
      v-bind:Unit="scoreUnit"
      v-bind:HideStudentName="true"
      v-bind:IsArchived="isArchived"
      @unarchive="unarchive"
      @delete-unit="deleteUnit"
      @archive-unit="archiveUnit"
    />
    <StudentBehaviorScores
      v-if="behaviorTracker != null"
      v-bind:Student="Student"
      v-bind:BehaviorTracker="behaviorTracker"
      v-bind:HideStudentName="true"
      v-bind:Users="Users"
      v-bind:BehaviorSettings="BehaviorSettings"
      @edited-tracker="editedTracker"
      @behavior-tracker-unarchived="unarchivedBehaviorTracker"
      @behavior-tracker-archived="archivedBehaviorTracker"
      @delete-behavior-tracker="deleteBehaviorTracker"
    />
    <AddBehaviorTrackerModal
      v-bind:ScoreTemplates="ScoreTemplates"
      v-bind:OrganizationId="
        parseInt(
          Student.Organizations.find(o => o.Organization_Type_Id == 6 || o.Organization_Type_Id == 7)
            .Parent_Organization_Id
        )
      "
      v-bind:Student="Student"
      v-bind:Users="Users"
      v-bind:BehaviorSettings="BehaviorSettings"
      @added-tracker="trackerAdded"
    />
    <ManageStudentOrganizationsModal
      v-bind:Student="Student"
      v-bind:Organizations="Organizations"
      @student-updated="studentUpdated"
    />
    <ManageStudentManagersModal
      v-bind:Student="Student"
      v-bind:Users="Users"
      @student-managers-updated="studentManagersUpdated"
    />
    <EditStudentModal
      v-bind:Student="Student"
      v-bind:Grades="Grades"
      @student-edited="studentEdited"
    />
    <ConfirmDeleteModal
      v-bind:DeletingTitle="deletingTitle"
      @confirm-delete="confirmDelete"
    />
  </div>
</template>

<script>
import StudentUnitScores from "@/components/Score/StudentUnitScores.vue";
import StudentBehaviorScores from "@/components/Score/StudentBehaviorScores.vue";
import AddBehaviorTrackerModal from "@/modals/Student/AddBehaviorTrackerModal.vue";
import ManageStudentOrganizationsModal from "@/modals/Student/ManageStudentOrganizationsModal.vue";
import ManageStudentManagersModal from "@/modals/Student/ManageStudentManagersModal.vue";
import EditStudentModal from "@/modals/Student/EditStudentModal.vue";
import ConfirmDeleteModal from "@/modals/ConfirmDeleteModal.vue";
import $ from "jquery";

export default {
  components: {
    StudentUnitScores,
    AddBehaviorTrackerModal,
    StudentBehaviorScores,
    ManageStudentOrganizationsModal,
    EditStudentModal,
    ManageStudentManagersModal,
    ConfirmDeleteModal
  },
  props: {
    Student: Object,
    BackText: String,
    ScoreTemplates: Array,
    Users: Array,
    BehaviorSettings: Array,
    BehaviorTrackers: Array,
    Organizations: Array,
    Grades: Array
  },
  watch: {},
  data() {
    return {
      scoreTemplate: null,
      unitScores: null,
      scoreUnit: null,
      behaviorScoreTemplate: null,
      behaviorTracker: null,
      allSubjects: null,
      archivedStudentUnits: null,
      page: 1,
      isArchived: false,
      deletingTitle: "",
      unitToDelete: null,
      behaviorTrackerToDelete: null
    };
  },
  created() {},
  async mounted() {},
  methods: {
    async selectUnitScores(studentUnit) {
      this.scoreTemplate = null;
      this.isArchived = this.page == 2;
      this.$store.commit("updateLoading", true);
      await this.$getStudentUnitScores(studentUnit.Student_Unit_Id).then(
        unitScores => {
          this.unitScores = unitScores;
          this.scoreUnit = studentUnit.Unit;
          this.scoreTemplate = this.ScoreTemplates.find(
            t => t.Score_Template_Id == studentUnit.Unit.Score_Template_Id
          );
          this.$store.commit("updateLoading", false);
        }
      );
      this.behaviorTracker = null;
    },
    async selectBehaviorScores(tracker) {
      this.$store.commit("updateLoading", true);
      this.behaviorTracker = await this.$getBehaviorTracker(
        tracker.Behavior_Tracker_Id
      );
      this.$store.commit("updateLoading", false);
      this.scoreTemplate = null;
    },
    addBehavior() {
      $("#addBehaviorTrackerModal").modal("show");
    },
    trackerAdded(newTracker) {
      this.$emit("behavior-tracker-added", newTracker);
    },
    manageStudent() {
      $("#manageStudentOrganizationsModal").modal("show");
    },
    studentUpdated(student) {
      this.$emit("student-updated", student);
    },
    editStudent() {
      $("#editStudentModal").modal("show");
    },
    studentEdited(student) {
      this.$emit("student-edited", student);
    },
    manageStudentManagers() {
      $("#manageStudentManagersModal").modal("show");
    },
    studentManagersUpdated() {
      this.$emit("student-managers-updated");
    },
    editedTracker(editedTracker) {
      this.behaviorTracker = editedTracker;
      this.$emit("edited-tracker", editedTracker);
    },
    showCurrentData() {
      this.scoreTemplate = null;
      this.behaviorScoreTemplate = null;
      this.page = 1;
    },
    async showArchivedData() {
      this.$store.commit("updateLoading", true);
      await this.$getStudentArchivedData(this.Student.Student_Id).then(
        student => {
          this.allSubjects = student.All_Subjects;
          this.archivedStudentUnits = student.Archived_Student_Units;
        }
      );
      this.scoreTemplate = null;
      this.behaviorTracker = null;
      this.$store.commit("updateLoading", false);
      this.page = 2;
    },
    async unarchive(unit) {
      this.$store.commit("updateLoading", true);
      var studentUnit = this.archivedStudentUnits.find(
        u => u.Unit.Unit_Id == unit.Unit_Id
      );
      await this.$unarchiveStudentUnits([studentUnit.Student_Unit_Id]);
      this.$store.commit("updateLoading", false);
      this.archivedStudentUnits = this.archivedStudentUnits.filter(
        u => u.Unit.Unit_Id != unit.Unit_Id
      );
      this.scoreTemplate = null;
      this.$emit(
        "student-unit-unarchived",
        this.Student.Student_Id,
        studentUnit
      );
    },
    deleteUnit(unit) {
      this.behaviorTrackerToDelete = null;
      this.deletingTitle = this.Student.Name + " - " + unit.Title;
      this.studentUnitToDelete = this.archivedStudentUnits.find(
        u => u.Unit.Unit_Id == unit.Unit_Id
      );
      $("#confirmDeleteModal").modal("show");
    },
    async confirmDelete() {
      if (this.studentUnitToDelete != null) {
        await this.confirmDeleteUnit();
      }
      if (this.behaviorTrackerToDelete != null) {
        await this.confirmDeleteBehaviorTracker();
      }
    },
    async confirmDeleteUnit() {
      $("#confirmDeleteModal").modal("hide");
      this.$store.commit("updateLoading", true);
      await this.$deleteStudentUnits([
        this.studentUnitToDelete.Student_Unit_Id
      ]);
      this.archivedStudentUnits = this.archivedStudentUnits.filter(
        su => su.Student_Unit_Id != this.studentUnitToDelete.Student_Unit_Id
      );
      this.scoreTemplate = null;
      this.$store.commit("updateLoading", false);
    },
    async archiveUnit(unit) {
      this.$store.commit("updateLoading", true);
      await this.$archiveStudentUnitsPairs([
        { student: this.Student, unitIds: [unit.Unit_Id] }
      ]);
      this.scoreTemplate = null;
      this.$emit(
        "student-unit-archived",
        this.Student.Student_Id,
        this.Student.Student_Units.find(u => u.Unit.Unit_Id == unit.Unit_Id)
      );
      this.$store.commit("updateLoading", false);
    },
    unarchivedBehaviorTracker(behaviorTracker) {
      this.$emit("behavior-tracker-unarchived", behaviorTracker);
      this.behaviorTracker = null;
    },
    archivedBehaviorTracker(behaviorTracker) {
      this.$emit("behavior-tracker-archived", behaviorTracker);
      this.behaviorTracker = null;
    },
    deleteBehaviorTracker(behaviorTracker) {
      this.studentUnitToDelete = null;
      this.deletingTitle = this.Student.Name + " - " + behaviorTracker.Title;
      this.behaviorTrackerToDelete = behaviorTracker;
      $("#confirmDeleteModal").modal("show");
    },
    async confirmDeleteBehaviorTracker() {
      $("#confirmDeleteModal").modal("hide");
      this.$store.commit("updateLoading", true);
      await this.$deleteBehaviorTracker([
        this.behaviorTrackerToDelete.Behavior_Tracker_Id
      ]);
      this.$emit("behavior-tracker-deleted", this.behaviorTrackerToDelete);
      this.behaviorTracker = null;
      this.$store.commit("updateLoading", false);
    }
  }
};
</script>

<style scoped>
.archive-background {
  background-color: rgba(217, 83, 79, 0.2);
}
</style>
